import { Model } from "pinia-orm";

export default class UserNotification extends Model {
  static name = "UserNotification";
  static entity = "userNotifications";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      notification: this.attr(null), // Notification is serialised in the user_notification by the backend no need relation
      readDatetime: this.attr(null),
      recipientUser: this.attr(null), // RecipientUser is serialised in the user_notification by the backend no need relation
      isUpdating: this.boolean(false),
      isPinned: this.boolean(false),
      shouldSendCallback: this.boolean(false),
      callbackSent: this.boolean(false),
      extraData: this.attr({}),
    };
  }
}
